import { useEffect, useState } from "react";
import CampaignOverview from "../CampaignOverview";
import { ReactComponent as Impressions } from "../../../../assests/impression-icon.svg";
import { ReactComponent as CpmTotal } from "../../../../assests/total-price-us-icon.svg";
import { ReactComponent as Cpm } from "../../../../assests/cpm-total-price-icon.svg";
import { ReactComponent as AmountPaid } from "../../../../assests/amount-paid-icon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assests/download-icon.svg";
import { ReactComponent as CancelIcon } from "../../../../assests/cancel-icon.svg";
import { useMediaQuery } from "react-responsive";
import CampaignBillBoardsTable from "../campaignbillboards/CampaignBillboardTable";
import { ReactComponent as Duplicate } from "../../../../assests/duplicate-icon.svg";
import { ReactComponent as AddProduct } from "../../../../assests/add-producticon.svg";
import { ReactComponent as Delete } from "../../../../assests/delete_icon.svg";
import { ReactComponent as Share } from "../../../../assests/share-icon.svg";
import { ReactComponent as ExcelIcon } from "../../../../assests/export-excel-icon.svg";
import { ReactComponent as WarningProductImage } from "../../../../assests/oops-warning-icon.svg";
import { ReactComponent as Star } from "../../../../assests/ai-insight-icon.svg";
import "./../../products/ProductCard.css";
import {
  Button,
  Col,
  Row,
  Typography,
  Modal,
  Segmented,
  Spin,
  message,
  Tooltip,
  Space,
  Image,
} from "../../../common/utils/antd-imports/AntdImports";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./CampaignDetails.css";
import "../../../../main.css";
import "../../../../styles/GlobalStyle.css";
import {
  aiRecommendedProducts,
  buyerCampaigns,
  cartDetails,
  deleteMultipleProducts,
  getRfpRefreshedCamapignProducts,
  saveCampaignToCart,
} from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import CampaignDetailsQuote from "../../../common/quote/CampaignDetailsQuote";
import CampaignDetailsIO from "../../../common/io/CampaignDetailsIO";
import dayjs from "dayjs";
import {
  downloadInsertionOrder,
  downloadIOWithSign,
  downloadQuote,
} from "../../../../store/thunks/common-thunks/commonThunk";
import DuplicateCampaign from "../../../modal/duplicate-campaign/DuplicateCampaign";
import ShareCampaign from "../../../modal/share-campaign-modal/ShareCampaign";
import DeleteCamapign from "../../../modal/delete-campaign/DeleteCampaign";
import {
  DesktopProductCard,
  MobileProductCard,
} from "../../products/ProductCard";
import MakeOffer from "../../../modal/make-offer-modal/MakeOffer";
import GrossFee from "../../../modal/gross-fee-modal/GrossFee";
import ViewTermsPlan from "../../../modal/view-payment-terms/ViewTermsPlan";
import ViewRFP from "../../../modal/view-rfp-modal/ViewRFP";
import { getOfferDetails } from "../../../../store/thunks/seller-thunks/SellerThunk";
import "../../../../main.css";
import { formatToMMDDYYYY, formatToUSCurrency } from "../../utils/Utils";
import { ReactComponent as ChatBotSparkles } from "../../../../assests/chatbot-sparklesIcon.svg";
import BackArrow from "../../../../assests/back-arrow.svg";
import BreadcrumbNav from "../../bread-crumbs/BreadCrumb";
import TransferCampaignToBuyer from "../../../modal/transfer-campaign/TransferCampaignToBuyer";
import ExportExcel from "../../../modal/export-excel-modal/ExportExcel";
import { ReactComponent as CartIcon } from "../../../../assests/cart-icon.svg";
import Checkbox from "antd/es/checkbox/Checkbox";
const { Text } = Typography;
const CampaignDetails = () => {
  const {
    selectedCampaignDetails,
    buyerCampaignsLoader,
    productQtyStatus,
    deleteProduct,
    isLoading: isQuantityLoading,
    isDuplicating,
    isDeleting,
    isDeletingCampaign,
    isRenamingLoading,
    deleteMultipleProductLoading,
  } = useSelector((state) => state.buyerCampaigns);
  const { recommendedProducts, isLoading: recommendationsLoader } = useSelector(
    (state) => state.airecommendations,
  );
  const { isRefreshLoading } = useSelector(
    (state) => state.rfpRefreshedProducts,
  );
  const {
    isLoading: campaignsLoader,
    ioPdf,
    quotePdf,
  } = useSelector((state) => state.sellerCampaigns);

  const { isLoading: cartLoader, isSaveCartLoading } = useSelector(
    (state) => state.campaignscart,
  );
  const { isDocuSignLoading, ioSignedPDF } = useSelector(
    (state) => state.docuSign,
  );
  const isLoading =
    buyerCampaignsLoader ||
    campaignsLoader ||
    cartLoader ||
    isSaveCartLoading ||
    recommendationsLoader ||
    isQuantityLoading ||
    isDuplicating ||
    isDeleting ||
    isDeletingCampaign ||
    isRenamingLoading ||
    isDocuSignLoading ||
    deleteMultipleProductLoading;
  const [expiredProduct, setExpiredProduct] = useState(false);
  const [transferCampaignFlag, setTransferCampaignFlag] = useState(false);
  const [expiredProducts, setExpiredProducts] = useState([]);
  const { grossFeeStatus } = useSelector((state) => state.grossfee);
  const [campaignInfo, setCampaignInfo] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [aiRecommended, setAIrecommended] = useState(false);
  const [isQuote, setIsQuote] = useState(false);
  const [grossFeeModal, setGrossFeeModal] = useState(false);
  const [viewTermsModal, setViewTermsModal] = useState(false);
  const [ioPrint, setIoPrint] = useState(false);
  const [shareCampaign, setShareCampaign] = useState(false);
  const [duplicateCampaign, setDuplicateCampaign] = useState(false);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const [campaignProducts, setCampaignProducts] = useState();
  const [offerModal, setOfferModal] = useState(false);
  const [viewRFPModal, setViewRFPModal] = useState(false);
  const [deleteProducts, setDeleteProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const soldStatuses = campaignInfo?.products?.some(
    (product) => product?.sold_status,
  );
  const [selectedSegment, setSelectedSegment] = useState("my_billboards");
  const [loggedInUser, setloggedInUser] = useState({
    clientId: null,
    user_id: null,
    email: null,
    firstName: null,
    lastName: null,
    user_type: null,
    user_role: null,
  });
  const [user, setUser] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  const other_id = params.get("_id"); // Access the query parameter
  const userInfo = JSON.parse(localStorage.getItem("user"))?.user;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isMedium = useMediaQuery({ minWidth: 426, maxWidth: 768 });
  const [offerRequested, setOfferRequested] = useState(false);
  const [offerTooltip, setOfferTooltip] = useState(false);
  const [exportColumnsModal, setExportColumnsModal] = useState(false);
  const isCustomTermsApplied = campaignInfo?.checkout_checked == 1;
  const { offerList, isLoading: offerListLoader } = useSelector(
    (state) => state.sellerCampaigns,
  );
  const restrictClick = () => {
    if (
      campaignInfo?.status > 100 ||
      (campaignInfo?.status == 100 && campaignInfo?.added_to_cart == 1)
    )
      return true;
    else return false;
  };
  const handleRestrict = () => {
    if (
      offerRequested ||
      offerTooltip ||
      campaignInfo?.status === 600 ||
      campaignInfo?.status == 700 ||
      campaignInfo?.status === 800 ||
      campaignInfo?.status === 1000 ||
      campaignInfo?.status === 1200
    )
      return true;
    else return false;
  };
  const addToCartButton = (
    <Button
      disabled={
        campaignInfo?.sold_status == 1 ||
        campaignInfo?.status > 100 ||
        !selectedCampaignDetails?.products?.length ||
        (campaignInfo?.status == 100 && campaignInfo?.added_to_cart == 1)
      }
      className={`add-to-cart redesigned-add-cart ${
        campaignInfo?.sold_status == 1 ||
        campaignInfo?.status > 100 ||
        !selectedCampaignDetails?.products?.length ||
        (campaignInfo?.status == 100 && campaignInfo?.added_to_cart == 1)
          ? "disable-button"
          : "pointer default-color"
      }`}
      size="large"
      onClick={() => {
        if (
          !restrictClick() &&
          selectedCampaignDetails?.products?.length > 0 &&
          campaignInfo?.sold_status != 1
        ) {
          handleAddtoCart();
        }
      }}
    >
      <CartIcon
        className="re-export-button-size"
        style={{ width: "18px", height: "auto" }}
      />
      {campaignInfo?.added_to_cart == 1 ? "Added to Cart " : "Add to Cart"}
    </Button>
  );
  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
    if (value === "ai_recommended_billboards") {
      setAIrecommended(true);
      setCampaignProducts(recommendedProducts);
    } else {
      setCampaignProducts(campaignInfo?.products);
      setAIrecommended(false);
    }
  };

  const handleOfferModal = () => {
    setOfferModal(true);
  };

  const offerLink = (
    <NavLink>
      <Text
        className={`campaign-overview-links-item common-text-color-red-13 ${
          !campaignInfo?.products_in_campaign ||
          (campaignInfo?.status > 100 && campaignInfo?.status < 1300)
            ? "disable-button"
            : "pointer"
        }`}
        onClick={() => {
          if (
            (campaignInfo?.products_in_campaign &&
              campaignInfo?.status > 100) ||
            campaignInfo?.status < 1300
          ) {
            handleOfferModal();
          }
        }}
      >
        Offer
      </Text>
    </NavLink>
  );
  //handle add to cart
  const handleAddtoCart = () => {
    let hasExpiredProduct = false;
    campaignInfo?.products?.forEach((product) => {
      const bookedToDate = new Date(product?.booked_to);
      const now = new Date();
      if (bookedToDate < now) {
        hasExpiredProduct = true;
        setExpiredProducts((prev) => [...prev, product]);
      }
    });
    if (hasExpiredProduct) {
      return;
    }
    const payload = {
      campaign_id: [atob(other_id)],
      loggedInUser,
    };
    if (soldStatuses) {
      message.warning(
        "Some products are already sold and cannot be added to the cart.",
      );
    } else {
      dispatch(saveCampaignToCart(payload))
        .then(() => {
          dispatch(cartDetails("campaignCart"));
          dispatch(buyerCampaigns(atob(other_id)));
        })

        .catch((err) => {
          console.error("Error in sequential dispatch:", err);
        });
    }
  };

  const exportColumnsToExcel = () => {
    setExportColumnsModal(true);
  };
  useEffect(() => {
    if (expiredProducts?.length > 0) {
      setExpiredProduct(true);
    }
  }, [expiredProducts]);

  useEffect(() => {
    dispatch(buyerCampaigns(atob(other_id))).then(() => {
      dispatch(aiRecommendedProducts(atob(other_id)));
    });
    const userInfo = localStorage.getItem("user");
    setUser(JSON.parse(userInfo));
  }, [other_id, productQtyStatus, grossFeeStatus, deleteProduct, dispatch]);

  useEffect(() => {
    // Reset campaign-specific UI state whenever campaign changes
    setOfferRequested(false);
    setOfferTooltip(false);
    setDeleteProducts([]);
    setOfferModal(false);
    setGrossFeeModal(false);
    setViewRFPModal(false);
    setShareCampaign(false);
    setDuplicateCampaign(false);
    setDeleteCampaignModal(false);
    setCampaignProducts(selectedCampaignDetails?.products);
    setCampaignInfo(selectedCampaignDetails);
    if (selectedCampaignDetails?.id) {
      dispatch(getOfferDetails(selectedCampaignDetails?.id));
    }
    setloggedInUser({
      clientId: null,
      user_id: user?.user?.user_id,
      email: user?.user?.email,
      firstName: user?.user?.firstName,
      lastName: user?.user?.lastName,
      user_type: user?.user?.user_type,
      user_role: user?.user?.user_role,
    });
  }, [selectedCampaignDetails, user, dispatch]);

  const getHideButton = () => {
    const requested =
      (offerList?.length === 1 && offerList[0]?.status === 10) ||
      (offerList?.length === 2 && offerList[1]?.status === 10);

    const accepted =
      (offerList?.length === 1 && offerList[0]?.status === 20) ||
      (offerList?.length === 2 && offerList[1]?.status === 20);

    setOfferRequested(requested);
    setOfferTooltip(accepted);
  };
  useEffect(() => {
    getHideButton();
  }, [offerList]);
  const getGrossFeeDisable = () => {
    if (
      (offerList?.length == 1 && offerList[0]?.status == 10) ||
      (offerList?.length == 2 && offerList[1]?.status == 10)
    )
      return true;
    else if (
      (offerList?.length == 1 && offerList[0].status == 20) ||
      (offerList?.length == 2 && offerList[1]?.status == 20)
    )
      return true;
    else return false;
  };

  const downloadIoOrQuote = () => {
    isQuote
      ? dispatch(downloadQuote(campaignInfo?.id))
      : dispatch(downloadInsertionOrder(campaignInfo?.id));
  };

  const downloadIO = () => {
    if (
      campaignInfo?.docusign_sign_status &&
      campaignInfo?.docusign_sign_status == 1
    ) {
      dispatch(downloadIOWithSign(campaignInfo?.envelope_id)).then(
        (response) => {
          message.success("Docusigned IO pdf has been downloaded");
        },
      );
    } else {
      dispatch(downloadInsertionOrder(campaignInfo?.id));
    }
  };
  useEffect(() => {
    if (isQuote || ioPrint) {
      const isSignedIo =
        campaignInfo?.docusign_sign_status == 1 ? ioSignedPDF : ioPdf;
      const pdfBlob = new Blob([isQuote ? quotePdf : isSignedIo], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = isQuote
        ? `Quote-${campaignInfo?.cid}.pdf`
        : `IO-${campaignInfo?.cid}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }, [ioPdf, ioSignedPDF, quotePdf]);

  const handleStateUpdate = ({ openDialog, isQuote, ioPrint }) => {
    setOpenDialog(openDialog);
    setIsQuote(isQuote);
    setIoPrint(ioPrint);
  };

  const handleShareCampaign = () => {
    setShareCampaign(true);
  };

  const handleAddProduct = () => {
    if (!campaignInfo) {
      console.error("campaignInfo is undefined or null");
      return;
    }

    // Store campaignId and campaignInfo properly
    localStorage.setItem("campaignId", campaignInfo.id);
    localStorage.setItem("CampaignDetails", campaignInfo);
    // Navigate with state
    navigate("/buyer/products", { state: { campaignId: campaignInfo?.id } });
  };

  const handleDuplicateCampaign = () => {
    setDuplicateCampaign(true);
  };
  const handleDeleteCampaign = () => {
    setDeleteCampaignModal(true);
  };

  const handleGrossFee = () => {
    setGrossFeeModal(true);
  };
  const handleTermsHistory = () => {
    setViewTermsModal(true);
  };

  const grossFeeLink = (
    <span
      className={`campaign-overview-links-item common-text-color-red-13 ${
        getGrossFeeDisable() ||
        campaignInfo?.status > 100 ||
        campaignInfo?.checkout_checked == 1
          ? "disable-button"
          : "pointer"
      }`}
      onClick={() => {
        if (
          !(
            getGrossFeeDisable() ||
            campaignInfo?.status > 100 ||
            campaignInfo?.checkout_checked == 1
          )
        )
          handleGrossFee();
      }}
      disabled={offerRequested}
    >
      Gross Fee
    </span>
  );
  const handleViewRfp = () => {
    setViewRFPModal(true);
  };

  const offerRequestedTooltip =
    "You cannot perform this action, when the offer is in requested state";
  const purchasedTooltip =
    "You cannot perform this action, when it is already purchased";
  const offerAcceptedTooltip =
    "You cannot perform this action, once your offer has been accepted.";
  const customTermsTooltip =
    "This action cannot be performed as custom terms are requested";
  const getToolTip = () => {
    if (offerRequested) return offerRequestedTooltip;
    else if (offerTooltip) return offerAcceptedTooltip;
    if (campaignInfo?.status > 100) return purchasedTooltip;
    // if (campaignInfo?.checkout_checked == 1) return customTermsTooltip;
    if (campaignInfo?.added_to_cart == 1)
      return "You cannot perform this action, when it is already in cart";
    if (!campaignInfo?.products)
      return "You cannot perform this action when there are no products in a campaign";
  };
  const tooltipForOffer = () => {
    if (campaignInfo?.status > 100 && campaignInfo?.status < 1300)
      return "You cannot request/view offer when it is already purchased";
    // if (campaignInfo?.checkout_checked == 1)
    //   return "You cannot request offer, when custom terms are requested";
    if (!campaignInfo?.products_in_campaign)
      return "You cannot perform this action when there are no products in a campaign";
  };
  const getAddtoCartTooltip = () => {
    // if (offerRequested) return offerRequestedTooltip;
    if (campaignInfo?.status > 100) return purchasedTooltip;
    if (campaignInfo?.added_to_cart == 1)
      return "You cannot perform this action, when it is already in cart";
    if (!selectedCampaignDetails?.products)
      return "This action cannot be performed when there are no products in the campaign.Please add a product to proceed.";
  };
  const handleDeleteProducts = () => {
    if (handleRestrict()) {
      return;
    }
    const payload = {
      campaign_id: campaignInfo?.id,
      product_booking_id: deleteProducts,
      product_offer_price: [],
    };
    dispatch(deleteMultipleProducts(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setDeleteProducts([]);
        setSelectAll(false);
        dispatch(buyerCampaigns(atob(other_id))).then(() => {
          if (campaignInfo?.products?.length > 0) {
            dispatch(aiRecommendedProducts(atob(other_id)));
          }
        });
      }
    });
  };
  const formatCount = (value) => {
    const count = value || 0;
    return count === 0 ? "0" : String(count).padStart(2, "0");
  };
  const isCampaignActionDisabled =
    campaignInfo?.status == 700 ||
    campaignInfo?.status === 800 ||
    campaignInfo?.status === 1000 ||
    campaignInfo?.status === 1200 ||
    campaignInfo?.status == 600;
  const handleRfpRefreshCampaign = (id) => {
    dispatch(getRfpRefreshedCamapignProducts(id)).then((res) => {
      if (res?.payload.status == 1) {
        dispatch(buyerCampaigns(atob(other_id)));
      }
    });
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const allProductIds =
        campaignInfo?.products?.map((product) => product.id) || [];
      setDeleteProducts(allProductIds);
    } else {
      setDeleteProducts([]);
    }
  };

  return (
    <>
      <div className="campaign-details-page-header">
        <Space direction="vertical">
          {isMobile ? (
            <> </>
          ) : (
            <>
              <BreadcrumbNav />
            </>
          )}
          <div style={{ display: "flex", alignItems: "center" }}>
            {isMobile && (
              <Image
                className="arrow-align pointer re-designed-arrow "
                src={BackArrow}
                preview={false}
                onClick={() => navigate(-1)}
              />
            )}
            <span className="campaign-details margin-class common-main-header-text">
              Campaign Details
            </span>
          </div>
        </Space>
        {/* future use  */}

        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              className="campaign-export-btn re-designed-export-btn"
              onClick={exportColumnsToExcel}
            >
              {" "}
              <ExcelIcon width={"18px"} height={"18px"} />
              <Text className="common-text-color-black-13">
                Export to Excel
              </Text>
            </Button>
            {campaignInfo?.status == 100 && (
              <>
                {offerRequested ||
                !selectedCampaignDetails?.products ||
                campaignInfo?.status > 100 ||
                campaignInfo?.added_to_cart == 1 ? (
                  <Tooltip title={getAddtoCartTooltip()}>
                    {addToCartButton}
                  </Tooltip>
                ) : (
                  <>{addToCartButton} </>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div className="campaign-details-parent-div re-designed-campaign-details-parent-div">
          <div className="campaign-details-div">
            <Row gutter={[16, 16]} style={{ width: "100%" }}>
              <Col className="gutter-row" style={{ width: "100%" }}>
                <CampaignOverview
                  customTermsApplied={
                    campaignInfo?.checkout_checked == 1 ? true : false
                  }
                  getToolTipContent={getToolTip}
                  offerTooltip={offerTooltip}
                  hideButton={offerRequested}
                  campaignInfo={campaignInfo}
                  onUpdateState={handleStateUpdate}
                  handleAddtoCart={handleAddtoCart}
                  handleOfferModal={handleOfferModal}
                  handleGrossFee={handleGrossFee}
                  handleViewRfp={handleViewRfp}
                  setTransferCampaignFlag={setTransferCampaignFlag}
                />
              </Col>

              {!isMobile ? (
                <></>
              ) : (
                // <>
                //   <Row
                //     gutter={[16, 10]}
                //     className="campaign-details-page-display"
                //   >
                //     <Col
                //       className="campaign-more-actions-container"
                //       style={{ height: "100px" }}
                //     >
                //       <div className="campaign-overview-total-impressions common-card-styles">
                //         <div>
                //           <Impressions className="campaign-icons" />
                //         </div>
                //         <div className="campaign-details-page-alignment">
                //           <span className="campaign-overview-header common-data-labels-grey">
                //             Total Impression
                //           </span>
                //           <span className="campaign-overview-common-css">
                //             {parseFloat(
                //               campaignInfo?.impressionSum || 0,
                //             ).toFixed(2) || "-"}
                //           </span>
                //         </div>
                //       </div>
                //     </Col>
                //     {/* <Col className="campaign-more-actions-container" span={11}>
                //     <div>
                //       <div className="campaign-overview-total-impressions">
                //         <div>
                //           <AmountPaid className="campaign-icons" />
                //         </div>
                //         <div className="campaign-details-page-alignment">
                //           <span className="campaign-overview-header">
                //             Amount Paid
                //           </span>
                //           <span className="campaign-overview-common-css">
                //             {" "}
                //             ${" "}
                //             {parseFloat(campaignInfo?.total_paid || 0).toFixed(
                //               2
                //             ) || "0"}
                //           </span>
                //         </div>
                //       </div>
                //     </div>
                //   </Col> */}
                //     <Col className="campaign-more-actions-container">
                //       <div className="campaign-overview-total-impressions">
                //         <div>
                //           <CpmTotal className="campaign-icons" />
                //         </div>
                //         <div className="campaign-details-page-alignment">
                //           <span className="campaign-overview-header">
                //             Total Price
                //           </span>
                //           <span className="campaign-overview-common-css">
                //             {formatToUSCurrency(
                //               parseFloat(
                //                 campaignInfo?.totalamount || 0,
                //               ).toFixed(2),
                //             ) || "NA"}
                //           </span>
                //         </div>
                //       </div>
                //     </Col>
                //   </Row>
                //   <Row
                //     gutter={[12, 12]}
                //     className="campaign-details-page-display"
                //   >
                //     <Col className="campaign-more-actions-container">
                //       <div className="campaign-overview-total-impressions">
                //         <div>
                //           <Cpm className="campaign-icons" />
                //         </div>
                //         <div className="campaign-details-page-alignment">
                //           <span className="campaign-overview-header">
                //             CPM Total
                //           </span>
                //           <span className="campaign-overview-common-css">
                //             $
                //             {parseFloat(campaignInfo?.cpmval || 0).toFixed(2) ||
                //               "-"}
                //           </span>
                //         </div>
                //       </div>
                //     </Col>
                //   </Row>
                // </>
                <></>
              )}

              {/* {isMobile && (
                <div style={{ width: "100%" }}>
                  <div className="my-billboards-tab">
                    <Segmented
                      onChange={handleSegmentChange}
                      className="campaign-segments common-card-styles"
                      size="small"
                      options={[
                        {
                          value: "my_billboards",
                          label: (
                            <div>
                              <Row justify="center" gap="5px" align="middle">
                                <span className="common-sub-header-black-14">
                                  My Products
                                </span>
                                <span className="selectedCount oval-shape-red-color-badge">
                                  {campaignInfo?.products?.length}
                                </span>
                              </Row>
                            </div>
                          ),
                        },
                        {
                          value: "ai_recommended_billboards",
                          label: (
                            <div>
                              <Row justify="space-between" align="middle">
                                <span>
                                  <ChatBotSparkles />{" "}
                                </span>
                                <span>AI Recommendations </span>
                                <span className="selectedCount">
                                  {recommendedProducts?.length}
                                </span>
                              </Row>
                            </div>
                          ),
                        },
                      ]}
                    />

                    <>
                      {deleteProducts?.length > 0 && (
                        <Button
                          type="primary"
                          className={`rfp-request-submit-button-css billboard-button-2 ${
                            handleRestrict() ? "disabled-opacity" : ""
                          }`}
                          onClick={handleDeleteProducts}
                          style={{ width: "50%" }}
                        >
                          Delete Products
                        </Button>
                      )}
                    </>
                  </div>
                  <Col
                    span={24}
                    className="campaign-more-actions-container"
                    style={{ paddingRight: "0px" }}
                  >
                    {aiRecommended ? (
                      <div>
                        <MobileProductCard
                          recommendedProducts={recommendedProducts}
                        />
                      </div>
                    ) : (
                      <div>
                        <CampaignBillBoardsTable
                          isCustomTermsApplied={
                            campaignInfo?.all_custom_terms_applied == 1
                              ? true
                              : false
                          }
                          getToolTipContent={getToolTip}
                          hideButton={offerRequested}
                          offerTooltip={offerTooltip}
                          campaignName={campaignInfo?.name}
                          campaignInfo={campaignProducts}
                          aiRecommended={aiRecommended}
                          campaignId={campaignInfo?.id}
                          campaignStatus={campaignInfo?.status}
                          deleteProducts={deleteProducts}
                          setDeleteProducts={setDeleteProducts}
                        />
                      </div>
                    )}
                  </Col>
                </div>
              )} */}
            </Row>
          </div>
          {isMobile && (
            <div className="campaign-more-actions-mobile-container">
              <div
                className="campaign-more-actions-mobile common-card-styles"
                onClick={handleShareCampaign}
              >
                <Share className="campaign-icons campaign-action-icons" />

                <span className="campaign-more-actions-text common-action-items-text-grey">
                  Share
                </span>
              </div>

              <div
                className={`campaign-more-actions-mobile common-card-styles ${
                  isCampaignActionDisabled ? "disabled-opacity" : ""
                }`}
                onClick={handleAddProduct}
              >
                <AddProduct
                  className="campaign-icons campaign-action-icons"
                  color="#d2042d"
                />

                <span className="campaign-more-actions-text common-action-items-text-grey">
                  Add Product
                </span>
              </div>

              <div
                className="campaign-more-actions-mobile common-card-styles"
                onClick={handleDuplicateCampaign}
              >
                <Duplicate className="campaign-icons campaign-action-icons" />

                <span className="campaign-more-actions-text common-action-items-text-grey">
                  Duplicate Campaign
                </span>
              </div>

              <div
                className={`campaign-more-actions-mobile common-card-styles ${
                  isCampaignActionDisabled ? "disabled-opacity" : ""
                }`}
                onClick={handleDeleteCampaign}
              >
                <Delete
                  className="campaign-icons campaign-action-icons"
                  style={{ color: "#d2042d" }}
                />

                <span className="campaign-more-actions-text common-action-items-text-grey">
                  Delete Campaign
                </span>
              </div>
            </div>
          )}
          <Row style={{ width: "100%", gap: "2%", marginTop: "20px" }}>
            <Col style={{ width: "48.5%" }}>
              <div className="campaign-overview-alignment">
                <div className="campaign-overview-total-impressions common-card-styles">
                  <div>
                    <Impressions className="campaign-icons" />
                  </div>
                  <div className="campaign-details-page-alignment">
                    <span className="campaign-overview-header common-data-labels-grey">
                      Total Impression
                    </span>
                    <span className="campaign-overview-common-css common-campaign-details-text-black-22">
                      {campaignInfo?.impressionSum || "0"}
                    </span>
                  </div>
                </div>

                <div className="campaign-overview-total-impressions common-card-styles">
                  <div>
                    <Cpm className="campaign-icons" />
                  </div>
                  <div className="campaign-details-page-alignment">
                    <span className="campaign-overview-header common-data-labels-grey">
                      CPM Total
                    </span>
                    <span className="campaign-overview-common-css common-campaign-details-text-black-22">
                      {campaignInfo?.offer_applied_res == 1
                        ? formatToUSCurrency(
                            parseFloat(campaignInfo?.offercpmval || 0).toFixed(
                              2,
                            ),
                          )
                        : formatToUSCurrency(
                            parseFloat(campaignInfo?.cpmval || 0).toFixed(2),
                          ) || "-"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col style={{ width: "48.5%" }}>
              <div className="campaign-overview-alignment">
                <div className="campaign-overview-total-impressions common-card-styles">
                  <div>
                    <CpmTotal className="campaign-icons" />
                  </div>
                  <div className="campaign-details-page-alignment">
                    <span className="campaign-overview-header common-data-labels-grey">
                      Total Price
                    </span>
                    <span className="campaign-overview-common-css common-campaign-details-text-black-22">
                      {formatToUSCurrency(
                        parseFloat(campaignInfo?.totalamount || 0).toFixed(2),
                      ) || "-"}
                    </span>
                  </div>
                </div>

                <div className="campaign-overview-total-impressions common-card-styles">
                  <div>
                    <AmountPaid className="campaign-icons" />
                  </div>
                  <div className="campaign-details-page-alignment">
                    <span className="campaign-overview-header common-data-labels-grey">
                      Amount Paid
                    </span>
                    <span className="campaign-overview-common-css common-campaign-details-text-black-22">
                      {formatToUSCurrency(
                        parseFloat(campaignInfo?.total_paid || 0).toFixed(2),
                      ) || "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <>
            <div className="my-billboards-tab">
              <Segmented
                onChange={handleSegmentChange}
                className="campaign-segments"
                size="small"
                options={[
                  {
                    value: "my_billboards",
                    label: (
                      <div className="campaign-segment-label">
                        <span className="common-action-items-text-black-14">
                          My Products
                        </span>
                        <span
                          className={
                            selectedSegment === "my_billboards"
                              ? "selectedCount oval-shape-red-color-badge"
                              : "selectedCount campaign-count-inactive"
                          }
                        >
                          {formatCount(campaignInfo?.products?.length)}
                        </span>
                      </div>
                    ),
                  },
                  {
                    value: "ai_recommended_billboards",
                    label: (
                      <div className="campaign-segment-label">
                        <span className="common-action-items-text-grey-14 campaign-ai-label">
                          <ChatBotSparkles />
                          AI Recommendations
                        </span>

                        <span
                          className={
                            selectedSegment === "ai_recommended_billboards"
                              ? "selectedCount oval-shape-red-color-badge"
                              : "selectedCount campaign-count-inactive"
                          }
                        >
                          {formatCount(recommendedProducts?.length)}
                        </span>
                      </div>
                    ),
                  },
                ]}
              />
              {deleteProducts?.length > 0 && (
                <Tooltip
                  title={
                    "This action is permanent and cannot be undone. Please double-check before proceeding."
                  }
                >
                  <Button
                    type="primary"
                    className="rfp-request-submit-button-css billboard-button-2"
                    onClick={handleDeleteProducts}
                  >
                    Delete Products
                  </Button>
                </Tooltip>
              )}
            </div>
            {campaignInfo?.products?.length > 0 && (
              <label
                className={`delete-all ${handleRestrict() ? "disable-button" : ""}`}
                style={{
                  cursor: handleRestrict() ? "not-allowed" : "pointer",
                  width: "10%",
                }}
              >
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  disabled={handleRestrict()}
                />
                <span> {!selectAll ? "Select All" : "UnSelect All"} </span>
              </label>
            )}
            <div>
              {aiRecommended ? (
                <>
                  <div className="yellow-ai-insight-card ai-suggestion-div">
                    <ChatBotSparkles style={{ marginRight: "10px" }} />
                    <Text className="ai-insight-sub-text">
                      Based on your campaign goals and existing products, our AI
                      has curated these high-performing ad spaces for you.
                    </Text>
                  </div>
                  <div className="recommended-products">
                    <DesktopProductCard
                      recommendFlag={true}
                      recommendedProducts={recommendedProducts}
                      flag={true}
                      campaignId={campaignInfo?.id}
                      campaignName={campaignInfo?.name}
                    />
                  </div>
                </>
              ) : (
                <>
                  <CampaignBillBoardsTable
                    isItemInCart={
                      campaignInfo?.checkout_checked == 1 ? true : false
                    }
                    getToolTipContent={getToolTip}
                    hideButton={offerRequested}
                    offerTooltip={offerTooltip}
                    campaignName={campaignInfo?.name}
                    campaignInfo={campaignProducts}
                    aiRecommended={aiRecommended}
                    campaignId={campaignInfo?.id}
                    campaignStatus={campaignInfo?.status}
                    isCustomTermsApplied={
                      campaignInfo?.all_custom_terms_applied == 1 ? true : false
                    }
                    deleteProducts={deleteProducts}
                    setDeleteProducts={setDeleteProducts}
                    offerList={offerList}
                    setSelectAll={setSelectAll}
                  />
                </>
              )}
            </div>
          </>
        </div>
        {!isMobile && (
          <div className="re-campaign-overview-alignment-container">
            <Col
              className="campaign-overview-alignment-container "
              style={{ width: "100%" }}
            >
              <div className="campaign-overview-links common-card-styles">
                {userInfo?.email ===
                  "richard.advertisingmarketplace@gmail.com" &&
                  campaignInfo?.status === 100 && (
                    <>
                      <span
                        className="campaign-overview-links-item pointer common-text-color-red-13"
                        onClick={() => {
                          setTransferCampaignFlag(true);
                        }}
                      >
                        Transfer Campaign
                      </span>

                      <div className="common-divider-horizontal" />
                    </>
                  )}

                {/* View Quote */}
                <span
                  className="campaign-overview-links-item pointer common-text-color-red-13"
                  onClick={() => {
                    setOpenDialog(true);
                    setIoPrint(false);
                    setIsQuote(true);
                  }}
                >
                  View Quote
                </span>

                <div className="common-divider-horizontal" />

                {/* Offer */}
                {campaignInfo?.status > 100 ||
                !campaignInfo?.products_in_campaign ||
                campaignInfo?.checkout_checked === 1 ? (
                  <Tooltip title={tooltipForOffer()}>{offerLink}</Tooltip>
                ) : (
                  <>{offerLink}</>
                )}

                <div className="common-divider-horizontal" />

                {/* View IO */}
                <span
                  className="campaign-overview-links-item pointer common-text-color-red-13"
                  onClick={() => {
                    setOpenDialog(true);
                    setIsQuote(false);
                    setIoPrint(true);
                    sessionStorage.removeItem("isDocusign");
                  }}
                >
                  View IO
                </span>

                <div className="common-divider-horizontal" />
                {offerRequested ||
                offerTooltip ||
                campaignInfo?.checkout_checked === 1 ||
                campaignInfo?.status > 100 ? (
                  <Tooltip title={getToolTip()}>{grossFeeLink}</Tooltip>
                ) : (
                  <>{grossFeeLink}</>
                )}

                {/* Divider only if View RFP or Payment Terms exists */}
                {(campaignInfo?.cmp_type === 1 ||
                  (campaignInfo?.status > 100 &&
                    campaignInfo?.campaign_terms_array?.length > 0)) && (
                  <div className="common-divider-horizontal" />
                )}

                {/* View RFP */}
                {campaignInfo?.cmp_type === 1 && (
                  <span
                    className="campaign-overview-links-item pointer common-text-color-red-13"
                    onClick={handleViewRfp}
                  >
                    View RFP
                  </span>
                )}
                {campaignInfo?.status == 1300 && (
                  <>
                    <div className="common-divider-horizontal" />
                    <span
                      className="campaign-overview-links-item pointer common-text-color-red-13"
                      onClick={() => {
                        handleRfpRefreshCampaign(campaignInfo?.id);
                      }}
                    >
                      Refresh Campaign
                    </span>
                  </>
                )}

                {/* Divider only if Payment Terms exists */}
                {/* {campaignInfo?.cmp_type === 1 &&
                  campaignInfo?.status > 100 &&
                  campaignInfo?.campaign_terms_array?.length > 0 && (
                    <div className="common-divider-horizontal" />
                  )} */}

                {/* View Payment Terms */}
                {/* {campaignInfo?.status > 100 &&
                  campaignInfo?.campaign_terms_array?.length > 0 && (
                    <span
                      className="campaign-overview-links-item pointer common-text-color-red-13"
                      onClick={handleTermsHistory}
                    >
                      View Payment Terms
                    </span>
                  )} */}
              </div>
            </Col>
            <Col
              className="campaign-overview-alignment-container "
              style={{ width: "100%" }}
            >
              <div className="campaign-overview-links yellow-ai-insight-card">
                <Row
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <ChatBotSparkles />
                  <Text className="ai-insight-text-color">AI Insight</Text>
                </Row>
                <Text className="ai-insight-sub-text">
                  Adding AI-recommended products can boost your campaign
                  impressions by up to{" "}
                  {<span className="ai-insight-text-color">40%</span>}.
                </Text>
              </div>
            </Col>
          </div>
        )}
      </div>
      <TransferCampaignToBuyer
        setTransferCampaignFlag={setTransferCampaignFlag}
        transferCampaignFlag={transferCampaignFlag}
        campaignId={campaignInfo?.id}
      />
      <Modal
        className="view-io"
        title={
          <div className="view-io-title">
            <>
              <span className="view-io-title-content">
                {isQuote ? "View Quote" : "Insertion Order (IO)"}
              </span>
            </>
            <div className="campaign-details-io-div">
              <div className="view-io-download-div" onClick={downloadIoOrQuote}>
                <DownloadIcon color="#fff" />
                <span style={{ color: "#fff" }}>
                  {isQuote
                    ? "Download Quote PDF"
                    : campaignInfo?.docusign_sign_status == 1
                      ? "Download Docusigned IO PDF"
                      : "Download IO PDF"}
                </span>
              </div>
              <div
                className="campaign-details-io-cancel-div"
                onClick={() => setOpenDialog(false)}
              >
                <CancelIcon />
              </div>
            </div>
          </div>
        }
        centered
        open={openDialog}
        destroyOnHidden
        onOk={() => setOpenDialog(false)}
        onCancel={() => setOpenDialog(false)}
        footer={<></>}
        closeIcon={<></>}
        style={{ width: "50%" }}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "40%",
        }}
      >
        {isQuote ? (
          <CampaignDetailsQuote
            pdfLoader={campaignsLoader}
            campaignDetails={{
              id: campaignInfo?.cid,
              campaignId: campaignInfo?.id,
              name: campaignInfo?.name,
              startDate: formatToMMDDYYYY(campaignInfo?.startDate),
              endDate: formatToMMDDYYYY(campaignInfo?.endDate),
              totalDays:
                campaignInfo?.endDate &&
                campaignInfo?.startDate &&
                dayjs(campaignInfo.endDate).diff(
                  dayjs(campaignInfo.startDate),
                  "day",
                ) + 1,
              percentagevalue: campaignInfo?.percentagevalue,
              tax_percentage_amount_sum:
                campaignInfo?.tax_percentage_amount_sum,
              gross_fee_price: campaignInfo?.gross_fee_price,
              install_production_cost_sum:
                campaignInfo?.install_production_cost_sum,
              totalamount: parseFloat(campaignInfo?.totalamount || 0).toFixed(
                2,
              ),
              newprocessingfeeamtSum: campaignInfo?.newprocessingfeeamtSum,
              impressionSum: campaignInfo?.impressionSum,
              campaign_cpmval: campaignInfo?.campaign_cpmval,
              act_budget: campaignInfo?.act_budget,
              products: campaignInfo?.products,
            }}
          />
        ) : (
          <CampaignDetailsIO
            pdfLoader={campaignsLoader || isDocuSignLoading}
            campaignDetails={{
              id: campaignInfo?.cid,
              campaignId: campaignInfo?.id,
              name: campaignInfo?.name,
              status: campaignInfo?.status,
              startDate: formatToMMDDYYYY(campaignInfo?.startDate),
              endDate: formatToMMDDYYYY(campaignInfo?.endDate),
              totalDays:
                campaignInfo?.endDate &&
                campaignInfo?.startDate &&
                dayjs(campaignInfo?.endDate).diff(
                  dayjs(campaignInfo?.startDate),
                  "day",
                ) + 1,
              percentagevalue: campaignInfo?.percentagevalue,
              tax_percentage_amount_sum:
                campaignInfo?.tax_percentage_amount_sum,
              gross_fee_price: campaignInfo?.gross_fee_price,
              install_production_cost_sum:
                campaignInfo?.install_production_cost_sum,
              totalamount: parseFloat(campaignInfo?.totalamount || 0).toFixed(
                2,
              ),
              newprocessingfeeamtSum: campaignInfo?.newprocessingfeeamtSum,
              buyer_user_address: campaignInfo?.buyer_user_address,
              buyer_by_name: campaignInfo?.buyer_by_name,
              buyer_user_attn: campaignInfo?.buyer_user_attn,
              buyer_user_email: campaignInfo?.buyer_user_email,
              buyer_user_name: campaignInfo?.buyer_user_name,
              offer_comments: campaignInfo?.offer_comments,
              offer_individual_comments:
                campaignInfo?.offer_individual_comments,
              sponsor_yes_no: campaignInfo?.sponsor_yes_no,
              products: campaignInfo?.products,
              products_in_campaign: campaignInfo?.products_in_campaign,
              docusign_signed_pdf_path: campaignInfo?.docusign_signed_pdf_path,
              buyer_signature_path: campaignInfo?.buyer_signature_path,
              campaign_terms_array: campaignInfo?.campaign_terms_array,
            }}
          />
        )}
      </Modal>
      <Modal
        open={shareCampaign}
        footer={false}
        width={558}
        height={469}
        closable={false}
        centered
      >
        <ShareCampaign
          shareCampaign={shareCampaign}
          setShareCampaign={setShareCampaign}
          campaignId={campaignInfo?.id}
        />
      </Modal>
      <Modal
        open={duplicateCampaign}
        footer={false}
        // className="share-campaign-model "
        width={558}
        height={260}
        closable={false}
        centered
      >
        <DuplicateCampaign
          campaignName={campaignInfo?.name}
          duplicateEntireCampaign={duplicateCampaign}
          campaignId={campaignInfo?.id}
          setDuplicateEntireCampaign={setDuplicateCampaign}
        />
      </Modal>

      <DeleteCamapign
        setDeleteCampaignModal={setDeleteCampaignModal}
        deleteCampaignModal={deleteCampaignModal}
        deleteCampaignId={campaignInfo?.id}
        selectedCampaignPage={true}
      />
      {offerModal && (
        <MakeOffer
          totalPrice={campaignInfo?.totalamount}
          setOfferModal={setOfferModal}
          offerModal={offerModal}
          campaignProducts={campaignProducts}
          campaignId={campaignInfo?.id}
          loggedinUser={loggedInUser}
          offerListFromCampaign={offerList}
          offerListLoader={offerListLoader}
        />
      )}
      <GrossFee
        setGrossFeeModal={setGrossFeeModal}
        grossFeeModal={grossFeeModal}
        campaignId={campaignInfo?.id}
        grossFeeVal={campaignInfo?.gross_fee_percentage}
      />
      <ViewTermsPlan
        campaignTermsArray={campaignInfo?.campaign_terms_array}
        setViewTermsModal={setViewTermsModal}
        viewTermsModal={viewTermsModal}
      />
      <ViewRFP
        viewRFPModal={viewRFPModal}
        setViewRFPModal={setViewRFPModal}
        campaignInfo={campaignInfo}
        loggedInUser={loggedInUser}
      />
      <Modal
        open={expiredProduct}
        onCancel={() => {
          setExpiredProduct(false);
          setExpiredProducts([]);
        }}
        centered
        footer={false}
      >
        <div className="product-expired-conatiner">
          <Row className="product-expired-conatiner-row">
            <WarningProductImage />
          </Row>
          <Row
            className="product-expired-conatiner-row"
            style={{
              marginTop: "10px",
            }}
          >
            <Text className="expired-product-warning">
              Expired Product Warning!
            </Text>

            <Text className="prodcts-expired">
              The following products expired:
            </Text>
          </Row>
          <Row className="product-expired-conatiner-row">
            <Text className="prodcts-expired-names">
              <ol>
                {expiredProducts?.map((product) => (
                  <li key={product?.id}>
                    {product?.siteNo} - ${product?.title}
                  </li>
                ))}
              </ol>
            </Text>
          </Row>
        </div>
      </Modal>
      {exportColumnsModal && (
        <ExportExcel
          exportColumnsModal={exportColumnsModal}
          setExportColumnsModal={setExportColumnsModal}
          campaignId={campaignInfo?.cid}
          campaignProducts={campaignInfo?.products}
        />
      )}
      {(isLoading || isRefreshLoading) && <Spin size="large" fullscreen />}
    </>
  );
};
export default CampaignDetails;
